<template>
    <div id="forgotpassword">
        <div class="container m_t">
            <div class="center_title">
                <Title en="Forgot PassWord" chtFirst="忘記" chtSecond="密碼" :center="true"></Title>
            </div>
            <section class="content">
                <div class="global_title">忘記密碼</div>
                <div class="form">
                    <div class="input_span">
                        <span>請輸入電子信箱</span>
                        <input type="email" placeholder="輸入Email" v-model="Email" />
                    </div>
                    <div class="input_span">
                        <span>請輸入驗證碼</span>
                        <input type="text" placeholder="請輸入驗證碼" v-model="CheckId" />
                    </div>
                    <div class="id">
                        <Sidentify :identifyCode="identifyCode"></Sidentify>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            x="0px"
                            y="0px"
                            width="24"
                            height="24"
                            viewBox="0 0 172 172"
                            style=" fill:#000000;"
                            @click="refreshCode"
                        >
                            <g
                                fill="none"
                                fill-rule="none"
                                stroke="none"
                                stroke-width="1"
                                stroke-linecap="butt"
                                stroke-linejoin="miter"
                                stroke-miterlimit="10"
                                stroke-dasharray
                                stroke-dashoffset="0"
                                font-family="none"
                                font-weight="none"
                                font-size="none"
                                text-anchor="none"
                                style="mix-blend-mode: normal"
                            >
                                <path d="M0,172v-172h172v172z" fill="none" fill-rule="nonzero" />
                                <g fill="#333333" fill-rule="evenodd">
                                    <g id="surface1">
                                        <path
                                            d="M109.82357,31.85808c-13.10156,-5.76693 -27.88281,-6.66276 -41.62826,-2.32357c-26.11914,8.23047 -43.05599,33.00586 -41.29232,60.27278l-17.83268,1.17578c-2.29557,-35.5254 19.79232,-67.7754 53.75,-78.4974c19.87631,-6.27083 41.43229,-4.08724 59.71289,5.79492l17.10482,-18.2806l4.56315,50.69857l-53.69401,1.79167zM109.15169,159.51433c-7.5306,2.35156 -15.34115,3.55533 -23.0957,3.55533c-12.65365,0 -25.22331,-3.27539 -36.5612,-9.37825l-17.13281,18.30859l-4.53515,-50.69857l53.66601,-1.79167l-19.28841,20.63217c13.04557,5.73893 27.82682,6.66276 41.57226,2.32356c26.11914,-8.25846 43.08399,-33.06185 41.32031,-60.27278l17.80469,-1.17578c2.35156,35.4694 -19.76433,67.7474 -53.75,78.4974z"
                                        />
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </div>
                    <div class="btn_box">
                        <div class="Orange_btn islogin" @click="sendmail">
                            <a href="javascript:;">確定送出</a>
                        </div>
                    </div>
                </div>
            </section>
            <graybtn />
        </div>
        <loading v-if="isLoading"></loading>
    </div>
</template>

<script>
import Sidentify from "@/components/identify";
import API from "@/service/member";
export default {
    name: "forgotpassword",
    components: {
        Sidentify
    },
    props: {},
    data() {
        return {
            Email: "",
            CheckId: "",
            //圖形驗證
            identifyCode: "",
            // identifyCodes: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ",
            identifyCodes: "23456789ABCDEFGHJKMNPQRSTUVWXYZ",
            isLoading: false
        };
    },
    methods: {
        /*圖形驗證*/
        randomNum(min, max) {
            return Math.floor(Math.random() * (max - min) + min);
        },
        refreshCode() {
            this.identifyCode = "";
            this.makeCode(this.identifyCodes, 4);
            // console.log("當前驗證碼==", this.identifyCode);
        },
        makeCode(o, length) {
            for (let i = 0; i < length; i++) {
                this.identifyCode += o[this.randomNum(0, o.length)];
            }
        },
        sendmail() {
            const vm = this;

            if (vm.Email == "") {
                this.$swal({
                    type: "warning",
                    text: "信箱為空",
                    confirmButtonText: "確定"
                });
                return false;
            }
            if (vm.CheckId == "") {
                this.$swal({
                    type: "warning",
                    text: "驗證碼為空",
                    confirmButtonText: "確定"
                });
                return false;
            }
            if (vm.CheckId != vm.identifyCode) {
                this.$swal({
                    type: "warning",
                    text: "驗證碼錯誤",
                    confirmButtonText: "確定"
                }).then(() => {
                    vm.refreshCode();
                });
                return false;
            }
            vm.isLoading = true;
            API.getForgotPassword({ Email: vm.Email }).then(result => {
                setTimeout(function() {
                    vm.isLoading = false;
                }, 500);
                if (result == undefined || result == "undefined") {
                    this.$swal({
                        type: "error",
                        text: "信箱輸入錯誤",
                        confirmButtonText: "確定"
                    });
                } else {
                    this.$swal({
                        type: "success",
                        text: "送出成功，請到信箱收取信件",
                        confirmButtonText: "確定"
                    }).then(() => {
                        vm.Email = "";
                        vm.CheckId = "";
                        vm.refreshCode();
                    });
                }
            });
        }
    },
    computed: {},
    created() {
        const vm = this;
        vm.refreshCode(); //初始化圖形驗證
    },
    mounted() {},
    watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#forgotpassword .content {
    border: 8px solid #eee;
    padding: 20px;
    color: #666;
}
#forgotpassword .content .form {
    width: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
}
#forgotpassword .content .id {
    padding: 15px 0 15px 130px;
    width: 50%;
    display: flex;
    align-items: center;
}
#forgotpassword .content .id svg {
    margin-left: 15px;
    cursor: pointer;
    -moz-user-select: none; /* for Firefox */
    -webkit-user-select: none; /* for Chrome */
}
#forgotpassword .content .id svg:hover {
    animation-iteration-count: infinite;
    animation-name: oxxo;
    animation-duration: 5s;
}
#forgotpassword .content .btn_box {
    width: 165px;
    padding: 30px 0;
}
@keyframes oxxo {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
@media screen and (max-width: 767px) {
    /* Step 01 */
    #forgotpassword .content {
        padding: 20px 10px;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/forgotpassword.vue